export function OutlineArchivarIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.98096 7.99805H19.9794V18.078C19.9794 19.1388 19.1202 19.998 18.0594 19.998H5.90096C4.84016 19.998 3.98096 19.1388 3.98096 18.078V7.99805Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M13.9842 12.002H9.98096"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M4.90267 4H19.0627C20.1235 4 20.9827 4.8592 20.9827 5.92V7.9984H2.98267V5.92C2.98267 4.8592 3.84187 4 4.90267 4Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
